<template>
	<div class="app-nav-top">
		<nav>
			<ul class="menu">
				<li class="home">
					<router-link to="/">{{ title }}</router-link>
				</li>
				<li>
					<router-link to="/index">Index</router-link>
				</li>
				<li>
					<a href="#">How to...</a>
					<ul class="menu">
						<li v-for="howto in howToArticles"	:key="howto.id">
							<router-link :to="'/article-view?id=' + howto.id">{{ howto.title }}</router-link>
							<button class="action action-delete" v-if="isEditor" @click="openConfirmDialog(howto.id)">
								<i class="fa-solid fa-trash-can"></i>
							</button>
						</li>
						<li v-if="isEditor">
							<router-link to="/article-edit?type=HOW_TO">Add "How to" article</router-link>
						</li>
					</ul>
				</li>

				<li>
					<a href="#">Services</a>
					<ul class="menu">
						<li v-for="service in serviceArticles" :key="service.id">
							<router-link :to="'/article-view?id=' + service.id">{{ service.title }}</router-link>
							<button class="action action-delete" v-if="isEditor" @click="openConfirmDialog(service.id)">
								<i class="fa-solid fa-trash-can"></i>
							</button>
						</li>
						<li v-if="isEditor">
							<router-link to="/article-edit?type=SERVICE"> Add "Service" article</router-link>
						</li>
					</ul>
				</li>

				<li v-for="link in links" v-bind:key="link.url">
					<a :href="link.url">{{ link.title }}</a>
				</li>

				<li v-if="isEditor">
					<router-link to="/article-edit">Create Article</router-link>
				</li>
			</ul>

			<ul class="menu icons">

				<li>
					<div class="menu-popup" id="menu-popup-search-top" style="padding: 0; width: auto;">
						<SearchField />
					</div>
					<button class="menu-popup-toggle" @click="toggleMenuSearchTop">
						<i class="fas fa-magnifying-glass"></i>
					</button>
				</li>

				<li v-if="!isAuthenticated">
					<a :href="loginLink">
						<i class="fas fa-right-to-bracket"></i>
					</a>
				</li>

				<li v-if="!canNavigate && isAuthenticated" class="app-notifications" id="app-notifications"></li>

				<li v-if="!canNavigate && isAuthenticated" class="profile">
					<ul class="menu-popup" id="menu-popup-user-profile-top">
						<li>
							<a>Profile: {{userName}}</a>
						</li>
						<li>
							<button @click="logout">Logout</button>
						</li>
					</ul>
					<button class="menu-popup-toggle" @click="toggleMenuUserProfileTop">
						<i class="fad fa-user-tie" style="--fa-secondary-opacity: 1;"></i>
					</button>
				</li>

			</ul>

			<ConfirmDialog :message="'Remove article type?'" ref="confModal" @confirmdelete="removeArticleType" @refusedelete="$refs.confModal.hide()" />

		</nav>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchField from '../feature/search/SearchField';
import ConfirmDialog from '../shared/ConfirmDialog';
import Article from '../../services/article';
import Journal from '../../services/journal';
import ConsoleService from '../../services/console';
import {API_PATH} from '../../../config/config';

export default {
	name: 'Navigation',
	components: {
		SearchField,
		ConfirmDialog,
	},
	data: function () {
		return {
			HOW_TO: [],
			SERVICE: [],
			selectedId: '',
			loginLink: API_PATH + '/console/login',
			logoutLink: API_PATH + '/console/logout'
		};
	},
	computed: {
		...mapGetters(['isEditor', 'isAuthenticated', 'canNavigate', 'userName']),
		howToArticles: function () {
			return this.$store.getters.publishedIndexArticleByType('HOW_TO');
		},
		serviceArticles: function () {
			return this.$store.getters.publishedIndexArticleByType('SERVICE');
		},
		title: function() {
			return Journal.instance().journalTitle();
		},
		links: function() {
			return Journal.instance().journalLinks();
		}
	},
	mounted() {
		this.renderNotificationPanel();
	},
	methods: {
		removeArticleType: async function () {
			let id = this.selectedId;
			try {
				let article = (await Article.instance().getArticleById(id))
					.data;
				if (article) {
					article.articleType = null;
					await Article.instance().editArticle(article);
					Article.instance().events.emit('removetype', article.id);
					this.$store.dispatch('fetchIndexArticles');
					this.$refs.confModal.hide();
				}
			} catch (error) {
				console.error(error);
				this.selectedId = '';
				this.$refs.confModal.hide();
			}
		},
		openConfirmDialog: function (id) {
			this.selectedId = id;
			this.$refs.confModal.show();
		},
		toggleMenuUserProfileTop: function () {
			document.querySelector('#menu-popup-user-profile-top').classList.toggle('visible');
		},
		toggleMenuSearchTop: function () {
			document.querySelector('#menu-popup-search-top').classList.toggle('visible');
		},
		logout() {
			ConsoleService.instance().console.logout();
		},
		renderNotificationPanel() {
			ConsoleService.instance().console.renderNotificationPanel(
				document.getElementById('app-notifications'),
				{
					listNotificationsUrl: Journal.instance().notificationsDashboardUrl()
				}
			);
		}
	},
};
</script>
